/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as CommunicationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.communication.createTemplate'

export { $nsid }

/** Administrative action to create a new, re-usable communication (email for now) template. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    name: l.string(),
    contentMarkdown: l.string(),
    subject: l.string(),
    lang: l.optional(l.string({ format: 'language' })),
    createdBy: l.optional(l.string({ format: 'did' })),
  }),
  l.payload(
    'application/json',
    l.ref<CommunicationDefs.TemplateView>(
      (() => CommunicationDefs.templateView) as any,
    ),
  ),
  ['DuplicateTemplateName'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
